<template>
  <div class="content-card">
    <Image :source="content.image" class="content-card__image"/>
    <div class="content-card__content">
      <h3 class="title --small">{{ content.title }}</h3>
      <button class="content-card__button" @click="$store.dispatch('updateContentCard', content)">
        {{ $t('moreDetails') }}
        <span class="more-icon-container">
          <Icon id="plus" />
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import {Icon, Image} from '@/components/global'
import {HasContentMixin} from '@/mixins'

export default {
  name: 'ContentCard',
  mixins: [HasContentMixin],
  components: {Icon, Image}
}
</script>